export default function isValidHTMLElement(mountNode) {
  return mountNode && mountNode.nodeType === 1;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-utils/es/isValidHTMLElement.js
// module id = 871
// module chunks = 0